const RENTAL_INDEX_FIELD_ALIASES = {
  FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_PROPERTY_1: 'flatRate22',
  FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_PROPERTY_2: 'flatRate23',
  FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_PROPERTY_3: 'flatRate24',
  FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_ADDITIONAL_COSTS_1: 'flatRate25',
  FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_ADDITIONAL_COSTS_2: 'flatRate26',
  FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_ADDITIONAL_COSTS_3: 'flatRate27'
}

function normalizeRentalIndexFieldName(name) {
  return RENTAL_INDEX_FIELD_ALIASES[name] ?? name
}

const generateExcel = {
  data() {
    return {
      defaultFields: [
        { name: 'owner', category: 'property' },
        { name: 'propertyName', category: 'property' },
        { name: 'propertyId', category: 'property' },
        { name: 'propertyKeyDateServiceChargeSettlement', category: 'property' },
        { name: 'buildingName', category: 'building' },
        { name: 'buildingId', category: 'building' },
        { name: 'egid', category: 'building' },
        { name: 'constructionYear', category: 'building' },
        { name: 'street', category: 'building' },
        { name: 'houseNumber', category: 'building' },
        { name: 'zip', category: 'building' },
        { name: 'city', category: 'building' },
        { name: 'numericId', category: 'object' },
        { name: 'objectId', category: 'object' },
        { name: 'objectName', category: 'object' },
        { name: 'category', category: 'object' },
        { name: 'subcategory', category: 'object' },
        { name: 'area', category: 'object' },
        { name: 'rooms', category: 'object' },
        { name: 'floor', category: 'object' },
        { name: 'ewid', category: 'object' },
        { name: 'awn', category: 'object' },
        { name: 'status', category: 'object' },
        { name: 'position', category: 'object' },
        { name: 'valueQuota', category: 'object' },
        { name: 'volume', category: 'object' },
        { name: 'objectTag', category: 'object' },
        { name: 'firstTimeOccupancy', category: 'object' },
        { name: 'unusualAgreement', category: 'object' },
        { name: 'specialFeatures', category: 'object' },
        { name: 'salutation', category: 'tenantOwner', subgroup: 'tenant' },
        { name: 'name', category: 'tenantOwner', subgroup: 'tenant' },
        { name: 'firstName', category: 'tenantOwner', subgroup: 'tenant' },
        { name: 'lastName', category: 'tenantOwner', subgroup: 'tenant' },
        { name: 'email', category: 'tenantOwner', subgroup: 'tenant' },
        { name: 'workEmail', category: 'tenantOwner', subgroup: 'tenant' },
        { name: 'mobile', category: 'tenantOwner', subgroup: 'tenant' },
        { name: 'phone', category: 'tenantOwner', subgroup: 'tenant' },
        { name: 'tenantAddress', category: 'tenantOwner', subgroup: 'tenant' },
        { name: 'birthday', category: 'tenantOwner', subgroup: 'tenant' },
        { name: 'nationality', category: 'tenantOwner', subgroup: 'tenant' },
        { name: 'civilStatus', category: 'tenantOwner', subgroup: 'tenant' },
        { name: 'companyName', category: 'tenantOwner', subgroup: 'tenant' },
        { name: 'occupation', category: 'tenantOwner', subgroup: 'tenant' },
        { name: 'startOfContract', category: 'tenancy' },
        { name: 'endOfContract', category: 'tenancy' },
        { name: 'rentByDate', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'netRentMonthly', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'netRentPeriod', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'heatingAndAdditionalCosts', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'heatingAndAdditionalCostsPeriod', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'advancePayment', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'advancePaymentPeriod', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'flatRate', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'flatRatePeriod', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'flatRate22', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'flatRate23', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'flatRate24', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'flatRate25', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'flatRate26', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'flatRate27', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'additionalRentComponents', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'additionalRentComponentsPeriod', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'grossRentMonthly', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'grossRentPeriod', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'typeOfUse', category: 'tenancy' },
        { name: 'contractType', category: 'tenancy' },
        { name: 'contractNumber', category: 'tenancy' },
        { name: 'correspondenceAddress', category: 'tenancy' },
        { name: 'householdSize', category: 'tenancy' },
        { name: 'debtor', category: 'tenancy' },
        { name: 'guarantor', category: 'tenancy' },
        { name: 'subtenants', category: 'tenancy', subgroup: 'subtenancy' },
        { name: 'subtenancyStart', category: 'tenancy', subgroup: 'subtenancy' },
        { name: 'subtenancyEnd', category: 'tenancy', subgroup: 'subtenancy' },
        { name: 'netRentYearly', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'netRentM2Yearly', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'grossRentYearly', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'tax', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'taxNetRent', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'taxHeating', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'grossRentInclTax', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'targetNetRent', category: 'tenancy' },
        { name: 'marketNetRent', category: 'tenancy' },
        { name: 'dueDates', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'assignee', category: 'tenancy' },
        { name: 'opted', category: 'tenancy' },
        { name: 'taxable', category: 'tenancy' },
        { name: 'contractAmendments', category: 'tenancy' },
        { name: 'referenceInterestRateDate', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'referenceInterestRateEffective', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'referenceRatePossible', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'countryIndexBaseYear', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'countryIndexDate', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'countryIndexInflation', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'costIncreaseType', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'costIncreaseDate', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'costIncreaseValue', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'costIncreaseDatePossible', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'rentMonthlyDueBy', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'retentionOfRentEffective', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'retentionOfRentPossible', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'rentReduction', category: 'tenancy', subgroup: 'rentAdjustment' },
        { name: 'rentType', category: 'tenancy' },
        { name: 'depositType', category: 'tenancy' },
        { name: 'depositInstitute', category: 'tenancy' },
        { name: 'depositNumber', category: 'tenancy' },
        { name: 'depositAmount', category: 'tenancy' },
        { name: 'depositDue', category: 'tenancy' },
        { name: 'depositPaidAt', category: 'tenancy' },
        { name: 'depositPaidAmount', category: 'tenancy' },
        { name: 'depositPaidOut', category: 'tenancy' },
        { name: 'depositRefundedOn', category: 'tenancy' },
        { name: 'depositRefundAmount', category: 'tenancy' },
        { name: 'depositNote', category: 'tenancy' },
        { name: 'countryIndexDatePossible', category: 'tenancy' },
        { name: 'referenceInterestRateReservationPercentage', category: 'tenancy' },
        { name: 'referenceInterestRateReservationValue', category: 'tenancy' },
        { name: 'countryIndexInflationPossible', category: 'tenancy' },
        { name: 'countryIndexInflationReservationPercentage', category: 'tenancy' },
        { name: 'countryIndexInflationReservationValue', category: 'tenancy' },
        { name: 'tenantNoticePeriod', category: 'tenancy' },
        { name: 'tenantEarliestQuit', category: 'tenancy' },
        { name: 'tenantNoticeToQuit', category: 'tenancy' },
        { name: 'landlordNoticePeriod', category: 'tenancy' },
        { name: 'landlordEarliestQuit', category: 'tenancy' },
        { name: 'landlordNoticeToQuit', category: 'tenancy' },
        { name: 'terminationResponsible', category: 'tenancy' },
        { name: 'terminationType', category: 'tenancy' },
        { name: 'reasonOfTermination', category: 'tenancy' },
        { name: 'terminationJustification', category: 'tenancy' },
        { name: 'terminationCreatedOn', category: 'tenancy' },
        { name: 'terminationSentByTenantAt', category: 'tenancy' },
        { name: 'terminatedOn', category: 'tenancy' },
        { name: 'moveOutDate', category: 'tenancy' },
        { name: 'liabilityEndsAt', category: 'tenancy' },
        { name: 'possibleMoveInDateNextTenant', category: 'tenancy' },
        { name: 'unjustifiedUse', category: 'tenancy' },
        { name: 'unjustifiedUseFrom', category: 'tenancy' },
        { name: 'firstRentAdjustmentPossibleOn', category: 'tenancy' },
        { name: 'rentAdjustmentByMonth', category: 'tenancy' },
        { name: 'rentAdjustmentByPoints', category: 'tenancy' },
        { name: 'contractImputedAtIndex', category: 'tenancy' },
        { name: 'referenceMonthForIndex', category: 'tenancy' },
        { name: 'maximumRate', category: 'tenancy' },
        { name: 'rentAdjustmentNotification', category: 'tenancy' },
        { name: 'rentAdjustmentMonths', category: 'tenancy' },
        { name: 'rentAdjustmentAdditionalBenefit', category: 'tenancy' },
        { name: 'belowInitialRentAllowed', category: 'tenancy' },
        { name: 'additionalCostsAdjustmentAllowed', category: 'tenancy' },
        { name: 'optionFrom1', category: 'tenancy' },
        { name: 'optionFrom2', category: 'tenancy' },
        { name: 'optionFrom3', category: 'tenancy' },
        { name: 'optionFrom4', category: 'tenancy' },
        { name: 'optionUntil1', category: 'tenancy' },
        { name: 'optionUntil2', category: 'tenancy' },
        { name: 'optionUntil3', category: 'tenancy' },
        { name: 'optionUntil4', category: 'tenancy' },
        { name: 'renewalExerciseUntil1', category: 'tenancy' },
        { name: 'renewalExerciseUntil2', category: 'tenancy' },
        { name: 'renewalExerciseUntil3', category: 'tenancy' },
        { name: 'renewalExerciseUntil4', category: 'tenancy' },
        { name: 'optionType1', category: 'tenancy' },
        { name: 'optionType2', category: 'tenancy' },
        { name: 'optionType3', category: 'tenancy' },
        { name: 'optionType4', category: 'tenancy' },
        { name: 'automaticExtending1', category: 'tenancy' },
        { name: 'automaticExtending2', category: 'tenancy' },
        { name: 'automaticExtending3', category: 'tenancy' },
        { name: 'automaticExtending4', category: 'tenancy' },
        { name: 'optionPer1', category: 'tenancy' },
        { name: 'optionPer2', category: 'tenancy' },
        { name: 'optionPer3', category: 'tenancy' },
        { name: 'optionPer4', category: 'tenancy' },
        { name: 'earlyTerminationExerciseUntil1', category: 'tenancy' },
        { name: 'earlyTerminationExerciseUntil2', category: 'tenancy' },
        { name: 'earlyTerminationExerciseUntil3', category: 'tenancy' },
        { name: 'earlyTerminationExerciseUntil4', category: 'tenancy' },
        { name: 'costIncreaseReservationPercentage', category: 'tenancy' },
        { name: 'costIncreaseReservationValue', category: 'tenancy' },
        { name: 'depositClearingNumber', category: 'tenancy' },
        { name: 'depositZip', category: 'tenancy' },
        { name: 'depositCity', category: 'tenancy' },
        { name: 'depositStreet', category: 'tenancy' },
        { name: 'depositCountry', category: 'tenancy' },
        { name: 'depositValidFrom', category: 'tenancy' },
        { name: 'depositValidUntil', category: 'tenancy' },
        { name: 'netRentDueDate', category: 'tenancy' },
        { name: 'heatingAndAdditionalCostsDueDate', category: 'tenancy' },
        { name: 'grossRentDueDate', category: 'tenancy' },
        { name: 'advancePaymentDueDate', category: 'tenancy' },
        { name: 'taxRentYearly', category: 'tenancy' },
        { name: 'vacancyRentYearly', category: 'tenancy' },
        { name: 'tenancyInternalId', category: 'tenancy' },
        { name: 'netRentMarketing', category: 'marketing' },
        { name: 'heatingAndAdditionalMarketing', category: 'marketing' },
        { name: 'grossRentMarketing', category: 'marketing' },
        { name: 'statusMarketing', category: 'marketing' },
        { name: 'availableFrom', category: 'marketing' },
        { name: 'linkedContactRoleOnBuilding', category: 'linkedContact' },
        { name: 'linkedContactIndustry', category: 'linkedContact' },
        { name: 'linkedContactName', category: 'linkedContact' },
        { name: 'linkedContactAddress', category: 'linkedContact' },
        { name: 'linkedContactPhone', category: 'linkedContact' },
        { name: 'linkedContactMobile', category: 'linkedContact' },
        { name: 'linkedContactEmail', category: 'linkedContact' },
        { name: 'linkedContactWebsite', category: 'linkedContact' },
        { name: 'linkedContactNotes', category: 'linkedContact' }
      ]
    }
  }
}

export { generateExcel, normalizeRentalIndexFieldName, RENTAL_INDEX_FIELD_ALIASES }
